function updatePriceVisibility() {

    const variantSelect =
        document.querySelector('select[name="options[Size]"]');

    const priceBlock =
        document.querySelector('[id^="price-"]');

    const priceBenefits =
        document.querySelector('[id^="price-benefits-"]');

    const bundleBenefits =
        document.querySelector('[id^="bundle-benefits-"]');

    if (
        !variantSelect ||
        !priceBlock ||
        !priceBenefits ||
        !bundleBenefits
    ) return;

    const selected =
        variantSelect.value.toLowerCase();

    priceBlock.style.display = "";
    priceBenefits.style.display = "flex";
    bundleBenefits.style.display = "none";

    if (selected.includes("20 ml")) {

        priceBlock.style.display = "none";
        priceBenefits.style.display = "none";
        bundleBenefits.style.display = "block";

        bundleBenefits.innerHTML = `
            <h4>20 ml Bundle</h4>
            <ul>
                <li>Choose any 4 fragrances</li>
                <li>Premium Packaging</li>
                <li>Perfect for gifting</li>
            </ul>
        `;

    }

    if (selected.includes("5 ml")) {

        priceBlock.style.display = "none";
        priceBenefits.style.display = "none";
        bundleBenefits.style.display = "block";

        bundleBenefits.innerHTML = `
            <h4>5 ml Discovery Bundle</h4>
            <ul>
                <li>Choose any 12 fragrances</li>
                <li>Premium Packaging</li>
                <li>Perfect for gifting</li>
            </ul>
        `;

    }

}


document.addEventListener("DOMContentLoaded", () => {
  updatePriceVisibility();

  document.addEventListener('change', function(e){

    if (
      e.target &&
      e.target.matches('select[name="options[Size]"]')
    ) {

      setTimeout(function(){
        updatePriceVisibility();
      }, 300);

    }

  });
  const labels = document.querySelectorAll(
    '.product-form__input--pill label'
  );

  labels.forEach(label => {

    const size = label.textContent.trim();

    let subtitle = "";

    switch (size) {

      case "5 ml":
        subtitle = "Bundle Only";
        break;

      case "20 ml":
        subtitle = "Bundle Only";
        break;

      case "50 ml":
        subtitle = "Full Size";
        break;

    }

    const parts = size.split(" ");

    label.innerHTML = `
      <span class="essntl-size-number">${parts[0]}</span>
      <span class="essntl-size-unit">${parts[1]}</span>
      <span class="essntl-size-subtitle">${subtitle}</span>
    `;

  });

});